import * as keyapis_access_management_v1_group_pb from "./v1/keyapis_access_management_group_v1.pb";
import * as keyapis_access_management_v1_system_pb from "./v1/keyapis_access_management_system_v1.pb";
import * as keyapis_access_management_v1_template_pb from "./v1/keyapis_access_management_template_v1.pb";

export default {
  v1: {
    resources: {
      group: keyapis_access_management_v1_group_pb,
      system: keyapis_access_management_v1_system_pb,
      template: keyapis_access_management_v1_template_pb,
    },
  },
};
